import {getArrayFromCookies, saveArrayIntoCookies} from "../atBrowserUtils"

export default class ExpandedUsersStorage {
    constructor() {
        this.cookieName = "lockTableExpandedUsers";
        this.expandedUsers = this.loadExpandedUsers();
    }

    loadExpandedUsers() {
        return getArrayFromCookies(this.cookieName);
    }

    contains(userId) {
        for (var i = 0; i < this.expandedUsers.length; i++) {
            if (this.expandedUsers[i] == userId)
                return true;
        }
    }

    add(userId) {
        this.expandedUsers.push(userId);
        this.saveExpandedUsers();
    }

    remove(userId) {
        for (var i = 0; i < this.expandedUsers.length; i++) {
            if (this.expandedUsers[i] == userId) {
                this.expandedUsers.splice(i, 1);
                this.saveExpandedUsers();
                return;
            }
        }
    }

    saveExpandedUsers() {
        saveArrayIntoCookies(this.expandedUsers, this.cookieName);
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/ExpandedUsersStorage.js